export const createGoogleMapsLink = (
  xCoord: number,
  yCoord: number
): string => {
  return `https://www.google.com/maps/dir/?api=1&destination=${yCoord},${xCoord}`;
};
